import React from 'react';
import { ChevronDown } from 'lucide-react';

interface ScrollIndicatorProps {
  text?: string;
}

const ScrollIndicator = ({ text }: ScrollIndicatorProps) => {
  return (
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/90 text-center">
      {text && <span className="block text-lg sm:text-xl font-medium mb-3 tracking-wide">{text}</span>}
      <ChevronDown className="w-8 h-8 sm:w-10 sm:h-10 mx-auto animate-bounce" />
    </div>
  );
};

export default ScrollIndicator;